import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-configuracion-documento-icon-info',
  templateUrl: './configuracion-documento-icon-info.component.html',
  styleUrls: ['./configuracion-documento-icon-info.component.css']
})
export class ConfiguracionDocumentoIconInfoComponent implements OnInit {

  @Input() nombre: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
